import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Header from "./header";
import { setCountryOfToday } from "../../actions/game.action";
import { toast } from "react-toastify";
import countries from "../../constants/countries";
import capitals from "../../constants/capitals";
import currencies from "../../constants/currencies";
import languages from "../../constants/languages";
import {
  getRandomCountryForToday,
  sampleLanguageItems,
  sampleSevenItems,
  sampleStringItems,
} from "../../utils";

const MainLayout = ({ children }) => {
  const { i18n } = useTranslation();
  const { settings } = useSelector(({ user }) => user);

  useEffect(() => {
    i18n.changeLanguage(settings.language);
  }, [i18n, settings.language]);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const countryOfToday =
          countries[getRandomCountryForToday(countries.length)];

        const response = await fetch(
          `/data/${countryOfToday.Alpha2Code.toLocaleLowerCase()}/data.json`,
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const buffer = await response.arrayBuffer(); // Convert the response to ArrayBuffer
        const jsonString = new TextDecoder("utf-8").decode(buffer);
        const json = JSON.parse(jsonString);

        json.capital = capitals.find(
          (city) => city.Alpha2Code === json.Alpha2Code,
        );
        json.flags = sampleSevenItems(countries, json.Alpha2Code, 8);
        json.currency_choices = sampleStringItems(
          currencies,
          [json.currency_name],
          4,
        );
        json.languages_choices = sampleLanguageItems(
          languages,
          json.languages,
          9,
        );

        json.cities.sort();

        dispatch(setCountryOfToday(json));
      } catch (error) {
        toast.error(new Error(error).message);
      }
    };

    fetchData();
  }, [dispatch]);

  return (
    <>
      <ToastContainer
        position="top-center"
        newestOnTop={true}
        closeOnClick={true}
        limit={1}
        stacked={true}
        toastClassName={"bg-white dark:text-slate-100 dark:bg-slate-900"}
      />
      <div className="flex h-full min-h-screen w-full flex-auto flex-col items-center justify-start bg-white py-8 transition-all dark:bg-slate-900 dark:text-slate-100">
        <div className="relative flex h-full w-full max-w-lg flex-col items-start justify-center px-2">
          <Header />
          {children}
        </div>
      </div>
    </>
  );
};

export default MainLayout;
